/** @jsx jsx */
import { gql } from '@apollo/client';
import { BottleImagePlaceholder } from '@bottlebooks/gatsby-theme-base';
import { graphql } from 'gatsby';
import Image from 'gatsby-image';
import { jsx } from 'theme-ui';
import { getFixedImage } from '../../helpers/getImageProps';

const dimensions = {
  smaller: { width: 40, height: 40 },
  default: { width: [70, 100], height: [105, 150] },
  large: { width: [140, 200], height: [210, 300] },
};

const paddings = {
  smaller: {},
  default: { padding: [1, 2] },
  large: { padding: [1, 2] },
};

/**
 *
 * @param {object} props
 * @param {object} props.product
 * @param {keyof typeof dimensions} [props.size]
 * @param {string} [props.className]
 * @returns
 */
export default function ProductImage({
  product,
  size = 'default',
  className,
  ...rest
}) {
  if (!product) return null;
  const { bottleImage } = product;
  const hasImage = Boolean(bottleImage?.fixed);
  return (
    <div
      sx={{
        backgroundColor: 'background',
        position: 'relative',
        ...dimensions[size],
        ...paddings[size],
        boxSizing: 'content-box',
        color: 'lighterText',
      }}
      className={className}
    >
      {hasImage ? (
        <Image
          fixed={getFixedImage(bottleImage.fixed)}
          loading="auto"
          alt={product.name}
          style={{ width: null, height: null }}
          placeholderStyle={{ objectFit: null, filter: 'blur(5px)' }}
          sx={{
            borderRadius: 'default',
            ...dimensions[size],
            img: { objectFit: 'contain' },
          }}
          {...rest}
        />
      ) : (
        <BottleImagePlaceholder sx={{ width: '100%', height: '100%' }} />
      )}
    </div>
  );
}

export const fragments = graphql`
  fragment ProductImageSmaller_list on Product {
    bottleImage {
      fixed(width: 80, height: 80, crop: PAD, background: "#FFF0") {
        src
        width
        height
      }
    }
  }
  fragment ProductImage on Product {
    bottleImage {
      fixed(width: 100, height: 150, crop: PAD, background: "#FFF0") {
        src
        srcSet
        width
        height
        base64
      }
    }
  }

  fragment ProductImage_list on Product {
    bottleImage {
      fixed(width: 100, height: 150, crop: PAD, background: "#FFF0") {
        src
        width
        height
      }
    }
  }

  fragment ProductImageLarge on Product {
    bottleImage {
      fixed(width: 200, height: 300, crop: PAD, background: "#FFF0") {
        src
        srcSet
        width
        height
        base64
      }
    }
  }
`;

export const ProductImageFragment = gql`
  fragment ProductImage on Product {
    bottleImage {
      fixed(width: 100, height: 150, crop: PAD, background: "#FFF0") {
        src
        srcSet
        width
        height
        base64
      }
    }
  }
`;

export const ProductImageFragment_large = gql`
  fragment ProductImageLarge on Product {
    bottleImage {
      fixed(width: 200, height: 300, crop: PAD, background: "#FFF0") {
        src
        srcSet
        width
        height
        base64
      }
    }
  }
`;
